// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--Woze7","icon":"_7a3fb80146--icon--IKO1G","icon--inner":"_7a3fb80146--icon--inner--sAM5W","tooltip":"_7a3fb80146--tooltip--pHDMN"};